import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Observable, Subject, of, throwError } from 'rxjs';
import { catchError, debounceTime, switchMap } from 'rxjs/operators';

import { BagTrackerModel } from './../../shared/models/bagTrackerModel';
import { WebSocketService } from './websocket.service';

@Injectable()
export class ScoreTrackerService 
{

  apiUrl = environment.apiUrl;

  // Set Local Storage Variable
  localStorage = window.localStorage;  

  constructor(private http: HttpClient,
              private webSocketService: WebSocketService){}


  // ---------------------------------------------
  // Get Match Info for ScoreTracker Basic - SWAP
  // ---------------------------------------------
  getMatchInfo(eventInfo, matchID, gameID = 1)
  {
    let url = '';

    console.log('getMatchInfo : ', eventInfo.bracketType);
    console.log('getMatchInfo Game ID: ', gameID);

    if(gameID == null || gameID == undefined)
    {
      gameID = 1;
    }

    if(eventInfo.bracketType == 'S' 
    || eventInfo.bracketType == 'D' 
    || eventInfo.bracketType == 'X')
    {
      // TODO:
      url = `${ this.apiUrl }/api/v1/bracket-match-info/${ eventInfo.leagueID }?matchID=${ matchID }&gameID=${ gameID }`;
    }  
    else if(eventInfo.bracketType == 'T') // Teams
    {
      url = `${ this.apiUrl }/api/v1/teams-match-info/${ eventInfo.leagueID }?matchID=${ matchID }&gameID=${ gameID }`;
    }    
    else if(eventInfo.bracketType == 'P') // Swap
    {
      url = `${ this.apiUrl }/api/v1/swap-match-info/${ eventInfo.leagueID }?matchID=${ matchID }`;
    }
    else if(eventInfo.bracketType == 'W') // Rounders
    {
      url = `${ this.apiUrl }/api/v1/swiss-pairing-match-info/${ eventInfo.leagueID }?matchID=${ matchID }`;
    }    
    else if(eventInfo.bracketType == 'R')
    {
      url = `${ this.apiUrl }/api/v1/round-robin-match-info/${ eventInfo.leagueID }?matchID=${ matchID }`;
    }         
    
    return this.http.get(url);    
  }

  // ---------------------------------------------
  // Update Match Score - Observable
  // This is used so that debounceTime can be used
  // this way if the screen is clicked a bunch of times
  // it does not pound the server
  // ---------------------------------------------
  updateScoresBasic$(matchData$) 
  {
    return matchData$.pipe(
          debounceTime(900),
          // distinctUntilChanged(),
          switchMap((matchScoreObj) => this.webSocketService.emitUpdateScoreBasic(matchScoreObj))
      );
  }

  // ---------------------------------------------
  // Update Scores - Leaderboard and ScoreZone
  // ---------------------------------------------
  // updateScoresBasic(matchScoreObj)
  // {
  //   return this.webSocketService.emitUpdateScoreBasic(matchScoreObj);
  // }


  // ---------------------------------------------
  // Update Match Score - Observable
  // This is used so that debounceTime can be used
  // this way if the screen is clicked a bunch of times
  // it does not pound the server
  // Used by Round / ESPN / ScoreZone and Leaderboard
  // Send BagTrackerModel
  // Used for ScoreZone, different than updateScoresBasic because
  // of the data that is being sent
  // TODO: Merge with updateScoresBasic and come up with new name
  // ---------------------------------------------
  updateScoresRound$(bagTrackerModel$): Observable<any>
  {
    return bagTrackerModel$.pipe(
          debounceTime(800),
          // distinctUntilChanged(),
          switchMap((bagTrackerModelObj) => this.webSocketService.emitUpdateScoreRound(bagTrackerModelObj))
      );
  }

  // ---------------------------------------------
  // Update Inning Data For ScoreZone and Leaderboard
  // and Charts
  // ---------------------------------------------
  // updateScoresRound(bagTrackerModelObj)
  // {
  //   // console.log('updateScoresRound', bagTrackerModelObj);
  //   return this.webSocketService.emitUpdateScoreRound(bagTrackerModelObj);
  // }  


  // --------------------------------------------------
  // This socket will Connect to the Event Room
  // And listent for Scores to update TV Mode page
  // --------------------------------------------------
  // public getRealTimeScoresConnection(connectionInfo)
  // {
  //   return this.webSocketService.getRealTimeScoresConnection(connectionInfo);
  // }   

  // --------------------------------------------------
  // This socket will Connect to the Admins Room and listen for
  // Scores Saved From Matches using the Round Scoring and
  // send the data back to the Chart
  // --------------------------------------------------
  // public getMatchChartConnection(connectionInfo)
  // {
  //   return this.webSocketService.getMatchChartConnection(connectionInfo);
  // }   
  
  // --------------------------------------------------
  // This will subscribe to the matched Assigned to court 
  // and add the match to the inProgress List
  // --------------------------------------------------
  public onMatchAssignedToCourt()
  {
    return this.webSocketService.onMatchAssignToCourtSubject$;
  }

  // ---------------------------------------------
  // Get Socket Status - Observable 
  // ---------------------------------------------
  public getSocketStatus()
  {
    return this.webSocketService.socketStatusSubject$;
  }


  // ---------------------------------------------
  // Get Socket Status 
  // Directly Connect to the Server without subscribing to a RxJs Subject
  // ---------------------------------------------
  public connectToServer(uniqueDeviceInfo, joinEventID = null)
  {
    return this.webSocketService.connectToServer(uniqueDeviceInfo, joinEventID);
  }

  // ---------------------------------------------
  // Disconnect Socket From Server  
  // ---------------------------------------------
  disconnectFromServer()
  {
    // console.log('disconnect From Server');
    this.webSocketService.disconnectFromServer();

  }

  // ---------------------------------------------
  // Get LocalStorage Device Info
  // ---------------------------------------------
  public getLocalStorageDeviceInfo()
  {
    return this.webSocketService.getLocalStorageDeviceInfo();
  }


  // ---------------------------------------------
  // Get LocalStorage Device Info
  // ---------------------------------------------
  public setLocalStorageDeviceInfo(formData)
  {
    return this.webSocketService.setLocalStorageDeviceInfo(formData);
  }

  // ---------------------------------------------
  // Get LocalStorage Device Info
  // ---------------------------------------------
  public removeLocalStorageDeviceInfo()
  {
    localStorage.removeItem(`socketIOUniqueDeviceInfo`);   

  }

  // ---------------------------------------------
  // Let the Server Know that the Device is Connected and 
  // and successfully navigated to ScoreTracker  
  // This is used only on the admin portal - 
  //
  // *** Need to be removed from schedule not really reliable ****
  // If the schedule is refreshed then the status icon is incorrect
  // ---------------------------------------------
  // deviceNavigatedToScoreTracker(deviceDetails)
  // {
  //   // console.log('disconnect From Server');
  //   this.webSocketService.deviceNavigatedToScoreTracker(deviceDetails);

  // }  


  // --------------------------------------------------
  // This will subscribe to the data getting updated in 
  // on.updateScoreRound
  // Use this data to update the chart
  // --------------------------------------------------
  public getMatchChartData()
  {
    return this.webSocketService.matchChartDataSubject$;
  }   


  // --------------------------------------------------
  // This socket will Connect to the Event Room
  // And listent for Scores to update TV Mode page
  // --------------------------------------------------
  public emitSavedMatchScoresBasicFromDevice(saveMatchObj)
  {
    return this.webSocketService.emitSavedMatchScoresBasicFromDevice(saveMatchObj);
  } 


  // --------------------------------------------------
  // List for SavedMatchScoreSuccessfully FROM Device
  // Used for Updating Admin Schedule, TV Mode, updating
  // standings and next up
  // --------------------------------------------------
  public onSavedMatchScoresBasicFromDevice()
  {
    return this.webSocketService.savedMatchScoresBasicFromDeviceSubject$;
  } 


  // --------------------------------------------------
  // This socket will Connect to the Event Room
  // And listent for Scores to update TV Mode page
  // --------------------------------------------------
  public emitSavedMatchScoresBasicFromAdmin(saveMatchObj)
  {
    console.log('Emit Saved Match Score from Admin');
    return this.webSocketService.emitSavedMatchScoresBasicFromAdmin(saveMatchObj);
  } 


  // --------------------------------------------------
  // List for SavedMatchScoreSuccessfully FROM Device
  // Used for Updating Admin Schedule, TV Mode, updating
  // standings and next up
  // --------------------------------------------------
  public onSavedMatchScoresBasicFromAdmin()
  {
      return this.webSocketService.savedMatchScoresBasicFromAdminSubject$;
  } 

  public resetAdminSave(): void
  {
    this.webSocketService.resetAdminSave();
  }




  // --------------------------------------------------------------------------
  // Save the Games for Offline or App Crash
  // Created on BagTracker Component 
  // --------------------------------------------------------------------------
  setGameScoresLocalStorage(bagTrackerModel: BagTrackerModel)
  {
      // set in any of your ts file
      localStorage.setItem(`id-${bagTrackerModel.leagueID}-match-${bagTrackerModel.matchID}game-${bagTrackerModel.currentGameID}-gameScores`, JSON.stringify(bagTrackerModel));        
  }

  getGameScoresLocalStorage(leagueID, matchID, currentGameID)
  {
      return JSON.parse(this.localStorage.getItem(`id-${leagueID}-match-${matchID}game-${currentGameID}-gameScores`));
  }    

  removeGameScoresLocalStorage(bagTrackerModel: BagTrackerModel)
  {
      // set in any of your ts file
      localStorage.removeItem(`id-${bagTrackerModel.leagueID}-match-${bagTrackerModel.matchID}game-${bagTrackerModel.currentGameID}-gameScores`);          
  }

  checkForGameScores(bagTrackerModel: BagTrackerModel)
  {
      const jsonObj = this.localStorage.getItem(`id-${bagTrackerModel.leagueID}-match-${bagTrackerModel.matchID}game-${bagTrackerModel.currentGameID}-gameScores`);

      if(jsonObj != null)
      {
          return true;
      }
      else
      {
          return false;
      }
  }          


    // --------------------------------------------------------------------------
    // GameDetails JSON used for setting up the Bag Tracker Page
    // Created on Event Schedule Page from the Match Details
    // --------------------------------------------------------------------------
    setGameDetailsLocalStorage(match)
    {
        // set in any of your ts file
        this.localStorage.setItem(`id-${match.leagueID}-match-${match.matchID}game-${match.currentGameID}-gameDetails`, JSON.stringify(match));       
    }

    getGameDetailsLocalStorage(leagueID, gameID, matchID)
    {
        return this.localStorage.getItem(`id-${leagueID}-match-${matchID}game-${gameID}-gameDetails`);
    }       

    removeGameDetailsLocalStorage(bagTrackerModel: BagTrackerModel)
    {
        // set in any of your ts file
        localStorage.removeItem(`id-${bagTrackerModel.leagueID}-match-${bagTrackerModel.matchID}game-${bagTrackerModel.currentGameID}-gameDetails`);          
    }   


    // ---------------------------------------------
    // Used to make sure if you are clicking multiple buttons fast enough
    // it only sends the last button click
    // ---------------------------------------------
    updateInningScoreRxJs(typeParm, bagTrackerModel$: Observable<any>) 
    {
      // console.log('updateInningScoreRxJs --- RXJS');
      return bagTrackerModel$.pipe(
        debounceTime(400),
        // distinctUntilChanged(),
        switchMap(bagTrackerModel => this.updateInningScores(typeParm, bagTrackerModel).pipe(
          catchError(error => {
            console.error('Network error:', error);
            // Return an empty array (or any default value) on error.
            return of([]);            
          })
        ))
      );
    }

    // ---------------------------------------------
    // Save Scores to the server for Live Stats and Live Broadcasts
    // ---------------------------------------------
    updateInningScores(typeParm, bagTrackerModel: BagTrackerModel)
    {
      // console.log('Bag Tracker Service - BagTrackerModel -> ', bagTrackerModel);
      // console.log('UpdateInningScores() ----- 1');
     
      
      let url = `${ this.apiUrl }/api/v1/event-save-inning-scores/${ bagTrackerModel.leagueID }`;

      let matchInfoObj = 
      {
        leagueID: bagTrackerModel.leagueID,
        eventID: bagTrackerModel.leagueID,
        leagueSessionID: bagTrackerModel.leagueSessionID,
        leagueYear: bagTrackerModel.leagueYear,
        matchID: bagTrackerModel.matchID,
        gameID: bagTrackerModel.gameID,
        eventAdminID: bagTrackerModel['eventAdminID'],
        matchType: bagTrackerModel.matchType,
        bracketType: bagTrackerModel.bracketType,
        weekID: bagTrackerModel.weekID,
        whichteam: bagTrackerModel.whichteam,
        winningInning: bagTrackerModel.winningInning,
        roundLimit: bagTrackerModel.roundLimit,
        roundID: bagTrackerModel.roundID,
        matchStatusID: bagTrackerModel.matchStatusID,

        eventGroupID: bagTrackerModel.eventGroupID,
        eventGroupDesc: bagTrackerModel.eventGroupDesc,

        dupfromteam: bagTrackerModel.dupfromteam,
        duptoteam: bagTrackerModel.duptoteam,
        dupplayerid: bagTrackerModel.dupplayerid,

        inningsParms: bagTrackerModel.inningsParms,

        homeTeamID: bagTrackerModel.homeTeamID,
        homeScore: bagTrackerModel['homeScore'],
        homeColor: bagTrackerModel.homeTeamBagColor,
        homeTeam: bagTrackerModel['homeTeam'],

        awayTeamID: bagTrackerModel.awayTeamID,
        awayScore: bagTrackerModel['awayScore'],
        awayColor: bagTrackerModel.awayTeamBagColor,
        awayTeam: bagTrackerModel['awayTeam'], 
        courtID: bagTrackerModel['courtID'],
        leagueName: bagTrackerModel['leagueName'],
        eventName: bagTrackerModel['leagueName'],

        homeTeamPlayerIDs: bagTrackerModel.homeTeamPlayerIDs,
        awayTeamPlayerIDs: bagTrackerModel.awayTeamPlayerIDs,
        homePoints: bagTrackerModel.homePoints,
        awayPoints: bagTrackerModel.awayPoints,            

      };

      // Add the Team names to the save inning for cache purposes
      if(matchInfoObj.bracketType == 'T')
      {
        matchInfoObj['homeTeamName'] = matchInfoObj.homeTeam[0]?.poolTeamName;
        matchInfoObj['awayTeamName'] = matchInfoObj.awayTeam[0]?.poolTeamName;
      }     

      return this.http.post(url, matchInfoObj);
    }


    // Save Scores to the server for Live Stats and Live Broadcasts
    confirmGameScores(bagTrackerModel: BagTrackerModel)
    {
      // console.log('Bag Tracker Service - BagTrackerModel -> ', bagTrackerModel);      

      let url = `${ this.apiUrl }/api/v1/confirm-match/${ bagTrackerModel.leagueID }`;

      let matchInfoObj = 
      {

        leagueID: bagTrackerModel.leagueID,
        eventID: bagTrackerModel.leagueID,
        leagueSessionID: bagTrackerModel.leagueSessionID,
        leagueYear: bagTrackerModel.leagueYear,
        matchID: bagTrackerModel.matchID,
        gameID: bagTrackerModel.gameID,
        eventAdminID: bagTrackerModel['eventAdminID'],
        matchType: bagTrackerModel.matchType,
        bracketType: bagTrackerModel.bracketType,
        weekID: bagTrackerModel.weekID,
        whichteam: bagTrackerModel.whichteam,
        winningInning: bagTrackerModel.winningInning,
        roundLimit: bagTrackerModel.roundLimit,
        matchStatusID: bagTrackerModel.matchStatusID,

        eventGroupID: bagTrackerModel.eventGroupID,
        eventGroupDesc: bagTrackerModel.eventGroupDesc,

        dupfromteam: bagTrackerModel.dupfromteam,
        duptoteam: bagTrackerModel.duptoteam,
        dupplayerid: bagTrackerModel.dupplayerid,


        homeTeamID: bagTrackerModel.homeTeamID,
        homeScore: bagTrackerModel['homeScore'],
        homeColor: bagTrackerModel.homeTeamBagColor,
        homeTeam: bagTrackerModel['homeTeam'],

        awayTeamID: bagTrackerModel.awayTeamID,
        awayScore: bagTrackerModel['awayScore'],
        awayColor: bagTrackerModel.awayTeamBagColor,
        awayTeam: bagTrackerModel['awayTeam'],          

      };

      // console.log('About to Post Scores Data');

      return this.http.post(url, matchInfoObj).pipe(
        catchError(error => {
          console.error('Network error:', error);
          // Return an empty array (or any default value) on error.
          return of([]);            
        })
      );
    }    

    // ---------------------------------------------
    // Save Event Scores Match / Game Number 
    // Returns new Admin Schedule
    // ---------------------------------------------
    saveMatchScore(matchObj)
    {
      // const body = JSON.stringify(formParm);

      console.log('SaveMatchScores ------ 3');

      let url = '';

      if(matchObj.eventInfo.bracketType == 'S' || 
         matchObj.eventInfo.bracketType == 'D' || 
         matchObj.eventInfo.bracketType == 'X' || 
         matchObj.eventInfo.bracketType == 'T')
      {
        url = `${ this.apiUrl }/api/v1/event-save-scores/${matchObj.eventInfo.leagueID}?approvedby=device`;
      } 
      else if(matchObj.eventInfo.bracketType == 'P')
      {
        url = `${ this.apiUrl }/api/v1/swap-save-score/${matchObj.eventInfo.leagueID}?approvedby=device`;
      }
      else if(matchObj.eventInfo.bracketType == 'W')
      {
        url = `${ this.apiUrl }/api/v1/swiss-pairing-save-score/${matchObj.eventInfo.leagueID}?approvedby=device`;
      }  
      else if(matchObj.eventInfo.bracketType == 'R')
      {
        url = `${ this.apiUrl }/api/v1/round-robin-save-score/${matchObj.eventInfo.leagueID}?approvedby=device`;
      }            
      
      return this.http.post(url, matchObj).pipe(
        catchError(error => {
          console.error('Network error:', error);
          // Re-throw the error so the component's subscription can handle it
          return throwError(error);          
        })
      );
    }




    // ---------------------------------------------
    // New Combined Save End of Game - combines 3 api calls
    // Returns new Admin Schedule
    // ---------------------------------------------
    saveGameScoresAll(bagTrackerModel: BagTrackerModel, matchObj)
    {
      // console.log('saveGameScoresAll ----', matchObj);

      let url = `${ this.apiUrl }/api/v1/event-save-game-scores-all/${ matchObj.eventInfo.leagueID }?approvedby=device`;   

      let matchInfoObj = 
      {
        leagueID: bagTrackerModel.leagueID,
        eventID: bagTrackerModel.leagueID,
        adminID:  matchObj.eventInfo.adminID,
        eventInfo: matchObj.eventInfo,
        leagueSessionID: bagTrackerModel.leagueSessionID,
        leagueYear: bagTrackerModel.leagueYear,
        matchID: bagTrackerModel.matchID,
        gameID: bagTrackerModel.gameID,
        eventAdminID: bagTrackerModel['eventAdminID'],
        matchType: bagTrackerModel.matchType,
        bracketType: bagTrackerModel.bracketType,
        weekID: bagTrackerModel.weekID,
        whichteam: bagTrackerModel.whichteam,
        winningInning: bagTrackerModel.winningInning,
        roundLimit: bagTrackerModel.roundLimit,
        roundID: bagTrackerModel.roundID,
        matchStatusID: bagTrackerModel.matchStatusID,

        eventGroupID: bagTrackerModel.eventGroupID,
        eventGroupDesc: bagTrackerModel.eventGroupDesc,

        dupfromteam: bagTrackerModel.dupfromteam,
        duptoteam: bagTrackerModel.duptoteam,
        dupplayerid: bagTrackerModel.dupplayerid,

        inningsParms: bagTrackerModel.inningsParms,

        homeTeamID: bagTrackerModel.homeTeamID,
        homeScore: bagTrackerModel['homeScore'],
        homeColor: bagTrackerModel.homeTeamBagColor,
        homeTeam: bagTrackerModel['homeTeam'],

        awayTeamID: bagTrackerModel.awayTeamID,
        awayScore: bagTrackerModel['awayScore'],
        awayColor: bagTrackerModel.awayTeamBagColor,
        awayTeam: bagTrackerModel['awayTeam'],        
        
        homeTeamPlayerIDs: bagTrackerModel.homeTeamPlayerIDs,
        awayTeamPlayerIDs: bagTrackerModel.awayTeamPlayerIDs,
        homePoints: bagTrackerModel.homePoints,
        awayPoints: bagTrackerModel.awayPoints,          

      };      

      
      return this.http.post(url, {matchObj: matchObj, matchInfoObj: matchInfoObj}).pipe(
        catchError(error => {
          console.error('Network error:', error);
          // Re-throw the error so the component's subscription can handle it
          return throwError(error);          
        })
      );
    }



   

    // --------------------------------------------------------------------------
    // Set the Flag for Game Results -
    // Used for Navigating back from Game Results Page to the Team Schedule
    // --------------------------------------------------------------------------
    setGameResultsFlagLocalStorage()
    {
        // set in any of your ts file
        localStorage.setItem(`gamesResultsFlag`, 'true');        
    }

    getGameResultsFlagLocalStorage()
    {
        return this.localStorage.getItem(`gamesResultsFlag`);
    }   

    removeGameResultsFlagLocalStorage()
    {
        // set in any of your ts file
        localStorage.removeItem(`gamesResultsFlag`);          
    }     



    // ---------------------------------------------
    // Get LocalStorage Device Info
    // ---------------------------------------------
    public getLatestMatchInfo(): Observable<any>
    {
      return this.webSocketService.getLatestAssignedMatchInfo();
    }


}
